import { all } from "redux-saga/effects";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

export const actionTypes = {
  SetEncryptedHotelId: "[Set Encrypted Hotel ID] Action",
  ClearEncryptedHotelId: "[Clear Encrypted Hotel ID] Action",
};

const initialEncryptedHotelState = {
  encryptedHotelId: null,
};

export const reducer = persistReducer(
  {
    storage,
    key: "encrypted-hotel-id", // Unique key for encrypted hotel ID persistence
    whitelist: ["encryptedHotelId"],
  },
  (state = initialEncryptedHotelState, action) => {
    switch (action.type) {
      case actionTypes.SetEncryptedHotelId: {
        const { encryptedHotelId } = action.payload;
        return { ...state, encryptedHotelId };
      }

      case actionTypes.ClearEncryptedHotelId: {
        return { ...state, encryptedHotelId: null };
      }

      default:
        return state;
    }
  }
);

export const actions = {
  setEncryptedHotelId: (encryptedHotelId) => ({
    type: actionTypes.SetEncryptedHotelId,
    payload: { encryptedHotelId },
  }),
  clearEncryptedHotelId: () => ({
    type: actionTypes.ClearEncryptedHotelId,
  }),
};

export function* saga() {
  yield all([
    // Add saga effects here as needed
  ]);
}